export default __webpack_public_path__ + "static/img/vogue_scene_animated_0041.ea0e770.jpg";